import React from 'react';
import { useHistory } from 'react-router-dom';
import { Modal, SecondaryButton } from '../../components';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../util/routes';
import { updatePaywallAction } from '../../util/api';
import css from './SubscriptionRequiredModal.module.css';

const SubscriptionRequiredModal = (props) => {
    const {
        isOpen,
        onClose,
        onManageDisableScrolling,
        redirectTxId,
        redirectTxRole,
        paywallUserId,
    } = props;

    const history = useHistory();
    const routeConfiguration = useRouteConfiguration();

    // Update the "Action taken" cell in the paywall log. Best-effort: never block
    // the user flow if the logging call fails. The server decides whether the
    // value may overwrite an existing one ("Get subscription" always wins;
    // "Ignore subscription" only fills an empty cell).
    const recordAction = actionTaken => {
        updatePaywallAction({
            userId: paywallUserId,
            transactionId: redirectTxId,
            actionTaken,
        }).catch(() => { });
    };

    const handleGetSubscription = () => {
        recordAction('Get subscription');

        // Client-side navigation keeps this JS context alive, so the recordAction
        // request above still completes after we push.
        const url = createResourceLocatorString(
            'SubscriptionsPage',
            routeConfiguration,
            {},
            { redirectTxId, redirectTxRole }
        );
        history.push(url);
    };

    // Any way of closing (Cancel button, X, or Escape) counts as ignoring the
    // subscription.
    const handleClose = event => {
        recordAction('Ignore subscription');
        onClose(event);
    };

    return <Modal
        id="SubscriptionRequiredModal"
        isOpen={isOpen}
        onClose={handleClose}
        onManageDisableScrolling={onManageDisableScrolling}
        usePortal
    >
        <p className={css.title}>
            {redirectTxRole == "sale"
                ? "Request an introduction"
                : "Introduction requested"
            }
        </p>

        <p className={css.note}>
            {redirectTxRole == "sale"
                ? "To request an introduction and share files, choose your membership."
                : "To be introduced to the counterparty and share files, choose your membership."
            }
        </p>

        <button
            type="button"
            className={css.link}
            onClick={handleGetSubscription}
        >
            Get a subscription
        </button>

        <SecondaryButton
            className={css.close}
            onClick={handleClose}
        >
            Cancel
        </SecondaryButton>
    </Modal>
};

export default SubscriptionRequiredModal;
